// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-use-account-management {
  border-radius: 0px 0px 10px 10px;
}

.container_use-account-management {
  display: flex;
  flex-direction: column;
  gap: 32px;
  align-items: center;
  margin-top: 48px;
  margin-left: auto;
  margin-right: auto;
  width: 344px;
  min-height: calc(85vh - 120px);
}
.container_use-account-management h3 {
  color: #444;
  text-align: center;
  font-family: Roboto;
  font-size: 28px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}
.container_use-account-management h4 {
  color: #00254A;
  text-align: center;
  font-family: Roboto;
  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container_use-account-management p {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
}
.container_use-account-management p b {
  color: #00254A;
  font-family: Roboto;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px; /* 150% */
}`, "",{"version":3,"sources":["webpack://./src/infraestructure/pages/use-account-management/ups/style.scss"],"names":[],"mappings":"AAAA;EACG,gCAAA;AACH;;AAEA;EACG,aAAA;EACA,sBAAA;EACA,SAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,YAAA;EACA,8BAAA;AACH;AAAC;EACG,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAEJ;AAAC;EACG,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AAAC;EACG,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAEJ;AADE;EACE,cAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA,EAAA,SAAA;AAGJ","sourcesContent":[".header-use-account-management {\n   border-radius: 0px 0px 10px 10px;\n}\n\n.container_use-account-management {\n   display: flex;\n   flex-direction: column;\n   gap: 32px;\n   align-items: center;  \n   margin-top: 48px;\n   margin-left: auto;\n   margin-right: auto;\n   width: 344px;\n   min-height: calc(85vh - 120px);\n h3 {\n    color: #444;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 700;\n    line-height: normal;\n }\n h4 {\n    color: #00254A;\n    text-align: center;\n    font-family: Roboto;\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n }\n p {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 24px;\n  b {\n    color: #00254A;\n    font-family: Roboto;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: 24px; /* 150% */\n  }\n }\n\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
